import { render, staticRenderFns } from "./404page.vue?vue&type=template&id=0b8ee9bc&scoped=true"
import script from "./404page.vue?vue&type=script&lang=js"
export * from "./404page.vue?vue&type=script&lang=js"
import style0 from "./404page.vue?vue&type=style&index=0&id=0b8ee9bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8ee9bc",
  null
  
)

export default component.exports